var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "calendarRoot",
      staticStyle: { position: "relative" },
      attrs: { id: "calendar_page_wrapper" },
      on: { touchstart: _vm.handleTouchStart, touchend: _vm.handleTouchEnd },
    },
    [
      _c("MobilePlaceAndStaffFilter", {
        on: {
          change: function ($event) {
            return _vm.staffFilterChange($event)
          },
          closed: function ($event) {
            return _vm.handleMobilePlaceAndStaffFilterClosed()
          },
        },
      }),
      _c(
        "div",
        {
          staticClass: "bb-mobile-header",
          style:
            _vm.showNewEventActions ||
            _vm.selectedAppointment ||
            _vm.mobilePlaceAndStaffFilterOpened
              ? "z-index: 90"
              : "",
        },
        [
          _c(
            "div",
            { staticClass: "bb-mobile-header-left" },
            [
              _c(
                "button",
                {
                  staticClass: "mobile-sidebar-btn",
                  on: {
                    click: function ($event) {
                      return _vm.openMobileAside()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "feather feather-menu",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("line", {
                        attrs: { x1: "3", y1: "12", x2: "21", y2: "12" },
                      }),
                      _c("line", {
                        attrs: { x1: "3", y1: "6", x2: "21", y2: "6" },
                      }),
                      _c("line", {
                        attrs: { x1: "3", y1: "18", x2: "21", y2: "18" },
                      }),
                    ]
                  ),
                ]
              ),
              _c("MobilePeriodFilter", {
                attrs: { fullCalendar: _vm.calendar },
                on: {
                  change: function ($event) {
                    return _vm.periodChanged($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "bb-mobile-header-right" },
            [
              _c("MobileViewFilter", {
                attrs: { fullCalendar: _vm.calendar },
                on: {
                  change: function ($event) {
                    return _vm.periodChanged($event)
                  },
                  toggle: function ($event) {
                    return _vm.emitToggleOverlay()
                  },
                },
              }),
              _c(
                "button",
                {
                  staticClass: "ml-7",
                  on: {
                    click: function ($event) {
                      return _vm.openMobilePlaceAndStaffFilter()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "22",
                        height: "22",
                        viewBox: "0 0 22 22",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M18.0642 0H3.93577C1.76559 0 0 1.76559 0 3.93577V18.0643C0 20.2344 1.76559 22 3.93577 22H18.0643C20.2344 22 22 20.2344 22 18.0642V3.93577C22 1.76559 20.2344 0 18.0642 0ZM20.7109 18.0642C20.7109 19.5236 19.5236 20.7109 18.0642 20.7109H3.93577C2.47638 20.7109 1.28906 19.5236 1.28906 18.0642V3.93577C1.28906 2.47638 2.47638 1.28906 3.93577 1.28906H18.0643C19.5236 1.28906 20.7109 2.47638 20.7109 3.93577V18.0642Z",
                          fill: "#253342",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M18.5942 4.83262H8.77756C8.50767 4.03104 7.74949 3.4519 6.85806 3.4519C5.96663 3.4519 5.20845 4.03104 4.93856 4.83262H3.40625C3.0503 4.83262 2.76172 5.1212 2.76172 5.47715C2.76172 5.8331 3.0503 6.12168 3.40625 6.12168H4.9386C5.20849 6.92326 5.96667 7.5024 6.8581 7.5024C7.74953 7.5024 8.50772 6.92326 8.7776 6.12168H18.5943C18.9502 6.12168 19.2388 5.8331 19.2388 5.47715C19.2388 5.1212 18.9502 4.83262 18.5942 4.83262ZM6.85806 6.21333C6.45213 6.21333 6.12188 5.88308 6.12188 5.47715C6.12188 5.07122 6.45213 4.74097 6.85806 4.74097C7.26399 4.74097 7.59424 5.07122 7.59424 5.47715C7.59424 5.88308 7.26399 6.21333 6.85806 6.21333Z",
                          fill: "#253342",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M18.5942 10.3556H17.0619C16.792 9.55399 16.0338 8.97485 15.1424 8.97485C14.251 8.97485 13.4928 9.55399 13.2229 10.3556H3.40625C3.0503 10.3556 2.76172 10.6441 2.76172 11.0001C2.76172 11.3561 3.0503 11.6446 3.40625 11.6446H13.2229C13.4928 12.4462 14.251 13.0253 15.1424 13.0253C16.0338 13.0253 16.792 12.4462 17.0619 11.6446H18.5943C18.9502 11.6446 19.2388 11.3561 19.2388 11.0001C19.2388 10.6441 18.9502 10.3556 18.5942 10.3556ZM15.1424 11.7363C14.7365 11.7363 14.4063 11.406 14.4063 11.0001C14.4063 10.5942 14.7365 10.2639 15.1424 10.2639C15.5484 10.2639 15.8786 10.5942 15.8786 11.0001C15.8786 11.406 15.5484 11.7363 15.1424 11.7363Z",
                          fill: "#253342",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M18.5942 15.8784H11.539C11.2691 15.0768 10.511 14.4977 9.61953 14.4977C8.7281 14.4977 7.96992 15.0768 7.70003 15.8784H3.40625C3.0503 15.8784 2.76172 16.167 2.76172 16.5229C2.76172 16.8789 3.0503 17.1675 3.40625 17.1675H7.70003C7.96992 17.969 8.7281 18.5482 9.61953 18.5482C10.511 18.5482 11.2691 17.969 11.539 17.1675H18.5943C18.9502 17.1675 19.2388 16.8789 19.2388 16.5229C19.2388 16.167 18.9502 15.8784 18.5942 15.8784ZM9.61953 17.2592C9.21361 17.2592 8.88335 16.9289 8.88335 16.523C8.88335 16.117 9.21361 15.7868 9.61953 15.7868C10.0255 15.7868 10.3557 16.117 10.3557 16.5229C10.3557 16.9289 10.0255 17.2592 9.61953 17.2592Z",
                          fill: "#253342",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-alert",
        {
          staticClass: "calendar-alert d-flex",
          attrs: { show: _vm.alertVisible, dismissible: "" },
          on: {
            dismissed: function ($event) {
              return _vm.handleAlertDismiss()
            },
          },
        },
        [
          _c("img", { attrs: { src: _vm.alertImagePath } }),
          _c("div", { staticClass: "alert-text" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$t("calendar.alert.title")))]),
            _c("p", [_vm._v(_vm._s(_vm.$t("calendar.alert.text")))]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "row d-flex justify-content-between mb-5 pr-4 pl-4 calendar-filters",
        },
        [
          _c("PlaceFilter"),
          _c("StaffFilter", {
            on: {
              change: function ($event) {
                return _vm.staffFilterChange($event)
              },
            },
          }),
          _c("PeriodFilter", {
            attrs: {
              fullCalendar: _vm.calendar,
              periodTitle: _vm.currentCalendarTitle,
            },
            on: {
              change: function ($event) {
                return _vm.periodChanged($event)
              },
            },
          }),
          _c("ViewFilter", {
            attrs: { fullCalendar: _vm.calendar },
            on: {
              change: function ($event) {
                return _vm.periodChanged($event)
              },
            },
          }),
        ],
        1
      ),
      _c("FullCalendar", {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.hideAllEventPopovers,
            expression: "hideAllEventPopovers",
          },
        ],
        ref: "fullCalendar",
        attrs: { options: _vm.calendarOptions },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.handleNewEventOutsideClick,
              expression: "handleNewEventOutsideClick",
            },
          ],
          staticClass: "bb-new-event-container",
          class: _vm.newEventButtonActiveClass,
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showNewEventActions,
                  expression: "showNewEventActions",
                },
              ],
              staticClass: "bb-new-event-actions",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      _vm.createAppointment(_vm.newEventData)
                      _vm.toggleNewEventActions()
                    },
                  },
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.newEventButtonsShowIcon,
                        expression: "newEventButtonsShowIcon",
                      },
                    ],
                    staticClass: "far fa-calendar",
                  }),
                  _vm._v(_vm._s(_vm.newAppointmentButtonText) + " "),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      _vm.createAppointment({
                        ..._vm.newEventData,
                        type: "GROUP",
                      })
                      _vm.toggleNewEventActions()
                    },
                  },
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.newEventButtonsShowIcon,
                        expression: "newEventButtonsShowIcon",
                      },
                    ],
                    staticClass: "fa fa-users",
                  }),
                  _vm._v(
                    _vm._s(
                      _vm.$t("calendar.newEventActions.groupAppointment")
                    ) + " "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      _vm.createBlockedTime(_vm.newEventData)
                      _vm.toggleNewEventActions()
                    },
                  },
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.newEventButtonsShowIcon,
                        expression: "newEventButtonsShowIcon",
                      },
                    ],
                    staticClass: "far fa-clock",
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("calendar.newEventActions.blockTime")) +
                      " "
                  ),
                ]
              ),
            ]
          ),
          _vm.showNewEventButton
            ? _c("button", {
                staticClass: "btn bb-new-event-btn",
                class: _vm.newEventButtonActiveClass,
                domProps: { innerHTML: _vm._s(_vm.newEventToggleButtonHtml) },
                on: { click: _vm.toggleNewEventActions },
              })
            : _vm._e(),
        ]
      ),
      _c("MobileEventPopover", {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.handleMobileEventPopoverClickOutside,
            expression: "handleMobileEventPopoverClickOutside",
          },
        ],
        ref: "mobileEventPopover",
        attrs: { appointment: _vm.selectedAppointment },
        on: {
          editAppointment: function ($event) {
            return _vm.editAppointment($event)
          },
          cancelAppointment: function ($event) {
            return _vm.cancelAppointment($event)
          },
          approveAppointment: function ($event) {
            return _vm.approveAppointment($event)
          },
          editBlockTime: function ($event) {
            return _vm.editBlockedTime($event)
          },
          removeBlockTime: function ($event) {
            return _vm.deleteAppointment($event)
          },
        },
      }),
      _c("CancelAppointmentModal", { ref: "cancelAppointmentModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }